module.exports = __webpack_public_path__ + "static/media/1.2db8fdf4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/28011/1.jpg
// module id = 630
// module chunks = 0